module.exports = __webpack_public_path__ + "img/symbol_6.5e4c55e1.png";